/**
 * @fileoverview gRPC-Web generated client stub for bankpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: bankpb/account.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.bankpb = require('./account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.bankpb.AccountServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.bankpb.AccountServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.bankpb.Account,
 *   !proto.bankpb.CreateAccountResponse>}
 */
const methodDescriptor_AccountService_CreateAccount = new grpc.web.MethodDescriptor(
  '/bankpb.AccountService/CreateAccount',
  grpc.web.MethodType.UNARY,
  proto.bankpb.Account,
  proto.bankpb.CreateAccountResponse,
  /**
   * @param {!proto.bankpb.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.bankpb.CreateAccountResponse.deserializeBinary
);


/**
 * @param {!proto.bankpb.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.bankpb.CreateAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.bankpb.CreateAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.bankpb.AccountServiceClient.prototype.createAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/bankpb.AccountService/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateAccount,
      callback);
};


/**
 * @param {!proto.bankpb.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.bankpb.CreateAccountResponse>}
 *     Promise that resolves to the response
 */
proto.bankpb.AccountServicePromiseClient.prototype.createAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/bankpb.AccountService/CreateAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_CreateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.bankpb.UpdateAccountRequest,
 *   !proto.bankpb.UpdateAccountResponse>}
 */
const methodDescriptor_AccountService_UpdateAccount = new grpc.web.MethodDescriptor(
  '/bankpb.AccountService/UpdateAccount',
  grpc.web.MethodType.UNARY,
  proto.bankpb.UpdateAccountRequest,
  proto.bankpb.UpdateAccountResponse,
  /**
   * @param {!proto.bankpb.UpdateAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.bankpb.UpdateAccountResponse.deserializeBinary
);


/**
 * @param {!proto.bankpb.UpdateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.bankpb.UpdateAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.bankpb.UpdateAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.bankpb.AccountServiceClient.prototype.updateAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/bankpb.AccountService/UpdateAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAccount,
      callback);
};


/**
 * @param {!proto.bankpb.UpdateAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.bankpb.UpdateAccountResponse>}
 *     Promise that resolves to the response
 */
proto.bankpb.AccountServicePromiseClient.prototype.updateAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/bankpb.AccountService/UpdateAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_UpdateAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.bankpb.ReadAccountRequest,
 *   !proto.bankpb.ReadAccountResponse>}
 */
const methodDescriptor_AccountService_ReadAccount = new grpc.web.MethodDescriptor(
  '/bankpb.AccountService/ReadAccount',
  grpc.web.MethodType.UNARY,
  proto.bankpb.ReadAccountRequest,
  proto.bankpb.ReadAccountResponse,
  /**
   * @param {!proto.bankpb.ReadAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.bankpb.ReadAccountResponse.deserializeBinary
);


/**
 * @param {!proto.bankpb.ReadAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.bankpb.ReadAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.bankpb.ReadAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.bankpb.AccountServiceClient.prototype.readAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/bankpb.AccountService/ReadAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_ReadAccount,
      callback);
};


/**
 * @param {!proto.bankpb.ReadAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.bankpb.ReadAccountResponse>}
 *     Promise that resolves to the response
 */
proto.bankpb.AccountServicePromiseClient.prototype.readAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/bankpb.AccountService/ReadAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_ReadAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.bankpb.ListAccountRequest,
 *   !proto.bankpb.ListAccountResponse>}
 */
const methodDescriptor_AccountService_ListAccount = new grpc.web.MethodDescriptor(
  '/bankpb.AccountService/ListAccount',
  grpc.web.MethodType.UNARY,
  proto.bankpb.ListAccountRequest,
  proto.bankpb.ListAccountResponse,
  /**
   * @param {!proto.bankpb.ListAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.bankpb.ListAccountResponse.deserializeBinary
);


/**
 * @param {!proto.bankpb.ListAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.bankpb.ListAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.bankpb.ListAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.bankpb.AccountServiceClient.prototype.listAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/bankpb.AccountService/ListAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_ListAccount,
      callback);
};


/**
 * @param {!proto.bankpb.ListAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.bankpb.ListAccountResponse>}
 *     Promise that resolves to the response
 */
proto.bankpb.AccountServicePromiseClient.prototype.listAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/bankpb.AccountService/ListAccount',
      request,
      metadata || {},
      methodDescriptor_AccountService_ListAccount);
};


module.exports = proto.bankpb;

